/**
 * listFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function listFilter() {
    return function(input, join = ', ', finalJoin = ' and ') {
        if (!input || input.length === 0) {
            return '';
        }

        if (input.length === 1) {
            return input[0];
        }

        const array = input.slice(0);
        const last = array.pop();

        return array.join(join) + finalJoin + last;
    };
}
